
import { Component, Vue } from 'vue-property-decorator';
import { AuthService } from '../../../services/auth.service';

@Component
export default class LoginPage extends Vue {
  username = '';
  password = '';
  valid = false;
  loading = false;
  showPassword = false;
  errorMessage = '';

  rules = {
    required: (value: string) => !!value || 'Este campo es requerido'
  };

  async handleLogin() {
    if (!this.valid) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    try {
      const response = await AuthService.login({
        username: this.username,
        password: this.password
      });

      // Save auth data to store
      await this.$store.dispatch('auth/login', {
        accessToken: response.access_token,
        refreshToken: response.refresh_token,
        expiresIn: response.expires_in
      });

      // Fetch user info (including customer logo)
      try {
        const userInfo = await AuthService.getUserInfo();
        await this.$store.dispatch('auth/setUserInfo', userInfo);
      } catch (userInfoError) {
        console.error('Failed to fetch user info:', userInfoError);
        // Continue with navigation even if user info fetch fails
      }

      // Redirect to intended route or default to item claims page
      const redirectTo = this.$route.query.redirect as string;
      
      if (redirectTo && redirectTo !== '/login') {
        this.$router.push(redirectTo);
      } else {
        // Default: redirect to item claims page
        this.$router.push('/claims/');
      }
    } catch (error: any) {
      console.error('Login error:', error);
      
      if (error.response && error.response.status === 401) {
        this.errorMessage = 'Usuario o contraseña incorrectos';
      } else if (error.response && error.response.status === 400) {
        this.errorMessage = 'Datos de inicio de sesión inválidos';
      } else {
        this.errorMessage = 'Error al iniciar sesión. Por favor, intente nuevamente.';
      }
    } finally {
      this.loading = false;
    }
  }
}
